import { render, staticRenderFns } from "./UserApiHistory.vue?vue&type=template&id=10e61f80&scoped=true&"
import script from "./UserApiHistory.vue?vue&type=script&lang=js&"
export * from "./UserApiHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserApiHistory.vue?vue&type=style&index=0&id=10e61f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e61f80",
  null
  
)

export default component.exports